import { MyAbility } from '@/store/useAbilityStore';
import {CalendarDaysIcon, Cog6ToothIcon, EnvelopeIcon} from '@heroicons/react/24/outline';
import {
  AcademicCapIcon,
  BuildingStorefrontIcon,
  ComputerDesktopIcon,
  IdentificationIcon,
  RectangleGroupIcon,
  TvIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
// import {UserAbility} from 'auth/casl';

import {BriefcaseBusinessIcon, FilesIcon, FolderKanbanIcon, ScrollIcon} from 'lucide-react';
import {ReactNode} from 'react';
// ==============================|| MENU ITEMS ||============================== //

export type SidebarMenuItem = {
  title: string;
  path: string;
  icon?: ReactNode;
  hidden?: boolean;
  isActive?: boolean;
  submenu?: SidebarMenuItem[];
};

export function adminSidebarMenuItems(ability: MyAbility): SidebarMenuItem[] {
  return [
    {
      title: 'Dashboard',
      path: '/',
      icon: <ComputerDesktopIcon />,
      // hidden: ability.cannot('view', 'dashboard'),
    },
    {
      title: 'Dự án',
      path: '',
      icon: <FolderKanbanIcon />,
      submenu: [
        {
          title: 'Danh sách dự án',
          path: '/projects',
          icon: <BuildingStorefrontIcon />,
          // hidden: ability.cannot('list', 'projects'),
        },
        {
          title: 'Danh sách công việc',
          path: '/tasks',
          icon: <BuildingStorefrontIcon />,
          // hidden: ability.cannot('list', 'tasks'),
        },
        {
          title: 'Danh sách hợp đồng',
          path: '/project_contracts',
          icon: <BuildingStorefrontIcon />,
          // hidden: ability.cannot('list', 'project_contracts'),
        },
      ],
    },
    {
      title: 'Tổ chức',
      path: '',
      icon: <BriefcaseBusinessIcon />,
      submenu: [
        {
          title: 'Nhân viên',
          path: '/staffs',
          icon: <BuildingStorefrontIcon />,
          hidden: ability.cannot('list', 'staffs'),
        },
        {
          title: 'Phòng ban',
          path: '/departments',
          icon: <BuildingStorefrontIcon />,
          hidden: ability.cannot('list', 'departments'),
        },
        {
          title: 'Công việc',
          path: '/jobs',
          icon: <BuildingStorefrontIcon />,
          hidden: ability.cannot('list', 'jobs'),
        },
      ],
    },
    // {
    //   title: 'Truyền thông',
    //   path: '',
    //   icon: <AcademicCapIcon />,
    //   submenu: [
    //     {
    //       title: 'Bài đăng',
    //       path: '/posts',
    //       icon: <BuildingStorefrontIcon />,
    //       hidden: ability.cannot('list', 'posts'),
    //     },
    //     {
    //       title: 'Tin nhắn',
    //       path: '/messages',
    //       icon: <EnvelopeIcon />,
    //       hidden: ability.cannot('list', 'messages'),
    //     },
    //     {
    //       title: 'Thiết lập chuyên mục',
    //       path: '/categories',
    //       icon: <BuildingStorefrontIcon />,
    //       hidden: ability.cannot('list', 'categories'),
    //     },
    //   ],
    // },
    {
      title: 'Quản lý nội dung',
      path: '',
      icon: <FilesIcon />,
      // hidden: ability.cannot('view', 'dashboard'),
      submenu: [
        {
          title: 'Tài liệu',
          path: '/documents',
          icon: <TvIcon />,
          // hidden: ability.cannot('list', 'documents'),
        },
        {
          title: 'Quản lý ảnh',
          path: '/images',
          icon: <TvIcon />,
          hidden: true, //ability.cannot('list', 'images'),
        },
      ],
    },
    {
      title: 'Quản lý tài khoản',
      path: '',
      icon: <UserIcon />,
      // hidden: ability.cannot('view', 'dashboard'),
      submenu: [
        {
          title: 'Tất cả tài khoản',
          path: '/users',
          icon: <BuildingStorefrontIcon />,
          hidden: ability.cannot('list', 'users'),
        },
        {
          title: 'Phân quyền',
          path: '/roles',
          icon: <TvIcon />,
          hidden: ability.cannot('list', 'roles'),
        },
      ],
    },
    {
      title: 'Test',
      path: 'test',
      hidden: ability.cannot('view', 'test') || process.env.NODE_ENV !== 'development',
      icon: <RectangleGroupIcon />,
      submenu: [
        {
          title: 'Test submit',
          path: '/test/test-form-submit',
          icon: <i className="fas fa-plus" />,
          // hidden: ability.cannot('view', 'dashboard'),
        },
        {
          title: 'Test react flow',
          path: '/test/test-react-flow',
          icon: <i className="fas fa-plus" />,
          // hidden: ability.cannot('view', 'dashboard'),
        },
        {
          title: 'Test chat',
          path: '/test/chat',
          icon: <i className="fas fa-plus" />,
          // hidden: ability.cannot('view', 'dashboard'),
        },
        {
          title: 'Test access control',
          path: '/test/test-access-control',
          icon: <i className="fas fa-plus" />,
          // hidden: ability.cannot('view', 'dashboard'),
        },
        {
          title: 'Test tailwind',
          path: '/test/test-tailwind',
          icon: <i className="fas fa-plus" />,
          // hidden: ability.cannot('view', 'dashboard'),
        },
      ],
    },

    {
      title: 'Lịch sử hoạt động',
      path: '/activity_logs',
      icon: <ScrollIcon />,
      hidden: ability.cannot('list', 'logs'),
    },
    {
      title: 'Thông tin cá nhân',
      path: '/profile',
      icon: <IdentificationIcon />,
      // hidden: ability.cannot('view', 'dashboard'),
    },
    {
      title: 'Cài đặt website',
      path: '/settings',
      icon: <Cog6ToothIcon />,
      hidden: ability.cannot('update', 'settings'),
    },
  ];
}

export default adminSidebarMenuItems;
